import React, { useState, useEffect } from 'react';
import { getEspecialidadesMedico, deleteEspecialidadMedico, createEspecialidadMedico, updateEspecialidadMedico, getEspecialidadMedicoById } from '../services/especialidadMedicoService';
import '../styles/Professions.css';
import '../styles/theme/toast.css';

const EspecialidadMedicoManagement = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [especialidades, setEspecialidades] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [showForm, setShowForm] = useState(false);
  const [currentEspecialidad, setCurrentEspecialidad] = useState(null);
  const [formData, setFormData] = useState({ nombre: '', observacion: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  useEffect(() => {
    fetchEspecialidades();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize]);

  const fetchEspecialidades = async () => {
    try {
      const res = await getEspecialidadesMedico(page, pageSize);
      // When paginated, backend returns { data, total, page, pageSize, totalPages }
      const payload = res.data;
      let rows = [];
      if (Array.isArray(payload)) {
        rows = payload;
        setTotal(rows.length);
        setTotalPages(1);
      } else if (payload && payload.data) {
        rows = payload.data;
        setTotal(payload.total || 0);
        setTotalPages(payload.totalPages || 1);
      }

      const mapped = rows.map(e => ({
        id: e.ESPECIALIDAD_ID,
        codigo: e.ESPECIALIDAD_ID,
        nombre: e.ESPECIALIDAD_NOMBRE,
        descripcion: e.ESPECIALIDAD_OBSERVACION
      }));
      setEspecialidades(mapped);
    } catch (error) {
      setEspecialidades([]);
      setTotal(0);
      setTotalPages(1);
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.nombre.trim()) {
      newErrors.nombre = 'El nombre de la especialidad es requerido';
    } else if (formData.nombre.length < 3) {
      newErrors.nombre = 'El nombre debe tener al menos 3 caracteres';
    }
    if (!formData.observacion.trim()) {
      newErrors.observacion = 'La observación es requerida';
    } else if (formData.observacion.length < 10) {
      newErrors.observacion = 'La observación debe tener al menos 10 caracteres';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    // Limpiar error cuando el usuario empiece a escribir
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleCreate = () => {
    setFormData({ nombre: '', observacion: '' });
    setCurrentEspecialidad(null);
    setErrors({});
    setShowForm(true);
  };

  const handleEdit = async (especialidad) => {
    try {
      const res = await getEspecialidadMedicoById(especialidad.id);
      const data = Array.isArray(res.data) ? res.data[0] : res.data;
      setFormData({
        nombre: data.ESPECIALIDAD_NOMBRE || '',
        observacion: data.ESPECIALIDAD_OBSERVACION || ''
      });
      setCurrentEspecialidad(especialidad);
      setErrors({});
      setShowForm(true);
    } catch (error) {
      alert('Error al cargar la especialidad');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try {
      if (currentEspecialidad) {
        // Actualizar especialidad existente
        await updateEspecialidadMedico(currentEspecialidad.id, {
          ESPECIALIDAD_NOMBRE: formData.nombre,
          ESPECIALIDAD_OBSERVACION: formData.observacion
        });
        alert('Especialidad actualizada exitosamente');
      } else {
        // Crear nueva especialidad
        await createEspecialidadMedico({
          ESPECIALIDAD_NOMBRE: formData.nombre,
          ESPECIALIDAD_OBSERVACION: formData.observacion
        });
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
      }
      setLoading(false);
      await fetchEspecialidades();
      resetForm();
    } catch (err) {
      setLoading(false);
      setErrors({ api: err.response?.data?.message || 'Error al guardar especialidad' });
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar esta especialidad?')) {
      try {
        await deleteEspecialidadMedico(id);
        alert('Especialidad eliminada exitosamente');
        // Actualizar la lista tras eliminar
        fetchEspecialidades();
      } catch (error) {
        // Mostrar el mensaje de error real del backend
        const errorMessage = error.response?.data?.message || 'Error al eliminar la especialidad';
        alert(errorMessage);
      }
    }
  };

  const resetForm = () => {
    setFormData({ nombre: '', observacion: '' });
    setCurrentEspecialidad(null);
    setShowForm(false);
    setErrors({});
  };

  const filteredEspecialidades = especialidades.filter(especialidad =>
    especialidad.codigo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    especialidad.nombre?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    especialidad.descripcion?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      {showToast && (
        <div className="custom-toast custom-toast-success">
          ¡Especialidad registrada exitosamente!
        </div>
      )}
      <div className="professions-container">
        <div className="page-header">
          <div className="header-title">
            <h1>Gestión de Especialidades Médicas</h1>
            <p>Administra las especialidades médicas disponibles para los médicos</p>
          </div>
        </div>
        <div className="professions-actions">
          <div className="search-section">
            <div className="search-input">
              <input
                type="text"
                placeholder="Buscar por código, nombre o descripción..."
                value={searchTerm}
                onChange={handleSearch}
              />
              <button type="button" title="Buscar">
                <i className="fas fa-search"></i>
              </button>
            </div>
          </div>
          <button className="btn-primary create-btn" onClick={handleCreate}>
            <i className="fas fa-plus"></i>
            Registrar Especialidad
          </button>
        </div>
        <div className="professions-table-container">
          <table className="professions-table">
            <thead>
              <tr>
                <th>Código</th>
                <th>Nombre</th>
                <th>Descripción</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filteredEspecialidades.map(especialidad => (
                <tr key={especialidad.id}>
                  <td><span className="code-id-field">{especialidad.codigo}</span></td>
                  <td>{especialidad.nombre}</td>
                  <td>{especialidad.descripcion}</td>
                  <td className="actions-cell">
                    <button
                      className="action-btn"
                      title="Editar"
                      onClick={() => handleEdit(especialidad)}
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                    <button
                      className="action-btn delete-btn"
                      title="Eliminar"
                      onClick={() => handleDelete(especialidad.id)}
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="records-info" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
          <div>
            Mostrando <strong>{filteredEspecialidades.length}</strong> de <strong>{total}</strong> especialidades
          </div>
          <div className="pagination-controls" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <button className="btn-secondary" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>Anterior</button>
            <span> Página <strong>{page}</strong> de <strong>{totalPages}</strong> </span>
            <button className="btn-secondary" onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}>Siguiente</button>
            <label style={{ marginLeft: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span>Por página:</span>
              <select value={pageSize} onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
              </select>
            </label>
          </div>
        </div>

        {showForm && (
          <div className="modal-overlay">
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>
                  <i className="fas fa-notes-medical"></i>
                  {currentEspecialidad ? 'Editar Especialidad Médica' : 'Registrar Especialidad Médica'}
                </h3>
                <button className="modal-close" onClick={resetForm}>
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <form className="profession-form" onSubmit={handleSubmit}>
                <div className="form-section">
                  <h3>Información de la Especialidad</h3>
                  <div className="form-group">
                    <label htmlFor="nombre">
                      Nombre de la Especialidad <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="nombre"
                      name="nombre"
                      value={formData.nombre}
                      onChange={handleChange}
                      className={errors.nombre ? 'error' : ''}
                      placeholder="Ej: Cardiología"
                      disabled={loading}
                    />
                    {errors.nombre && <span className="error-message">{errors.nombre}</span>}
                  </div>
                  <div className="form-group">
                    <label htmlFor="observacion">
                      Observación <span className="required">*</span>
                    </label>
                    <textarea
                      id="observacion"
                      name="observacion"
                      value={formData.observacion}
                      onChange={handleChange}
                      className={errors.observacion ? 'error' : ''}
                      placeholder="Describe la especialidad..."
                      rows="4"
                      disabled={loading}
                    />
                    {errors.observacion && <span className="error-message">{errors.observacion}</span>}
                  </div>
                </div>
                {errors.api && <div className="form-error">{errors.api}</div>}
                <div className="form-actions">
                  <button type="button" className="btn-secondary" onClick={resetForm} disabled={loading}>
                    Cancelar
                  </button>
                  <button type="submit" className="btn-primary" disabled={loading}>
                    {loading ? (
                      <>
                        <i className="fas fa-spinner fa-spin"></i> Guardando...
                      </>
                    ) : (
                      currentEspecialidad ? 'Guardar Cambios' : 'Registrar Especialidad'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default EspecialidadMedicoManagement;
